 App.directive("variantsMatrix", ["Config", 'variantsMatrixService', function variantsMatrix(Config, variantsMatrixService) {
    return {
      restrict: "E",
      scope: {
        lifePackages: "<",
        isLifePackageDisabled: "&?",
        isLifePackageHidden: "&?",
        persons: "=",
        prices: "=",
        choose: "=",
        realDeclarationsNumber: "=?",
        summary: "=",
        requiredGroupsCount: "<?",
        singleItemGroupWeight: "<?",
        groupColors: "<?",
        announcement: "<?"
      },
      templateUrl: Config.TEMPLATES_DIR + "Components/variants-matrix.html",
      link: function (scope) {
        scope.groupwidth = [];
        scope.singleLength = [];
        scope.allLength = 0;
        scope.singleItemGroupWeight = scope.singleItemGroupWeight ? scope.singleItemGroupWeight : 2
        scope.requiredGroupsCount = scope.requiredGroupsCount ? scope.requiredGroupsCount : 2;
        scope.implicitPackagesPrice = 0;

        scope.addChild = function () {
          scope.persons.push({
            type: "CHILD",
            name: "Pełnoletnie dziecko",
            person: {
              citizenshipType: 'POLISH',
              gender: 'FEMALE'
            }
          });

          scope.prices[scope.persons.length - 1] = {};

          for (var b = 0; b < scope.lifePackages.length; b++) {
            scope.prices[scope.persons.length - 1][b] = 0;
          }

          scope.choose.push({});
        };

        scope.deleteChild = function (obj) {
          scope.persons.splice(obj, 1);
          scope.prices.splice(obj, 1);
          scope.choose.splice(obj, 1);
          recalculateSummary();
          markVisibilityOfForms();
          realDeclarationsNumber();
        };

        scope.checkPrice = function (person, group, price) {
          scope.prices[person][group] = price;
          for (let i = 0; i < scope.lifePackages.length; i++) {
            if (scope.isImplicit(scope.lifePackages[i])) {
              scope.choose[person][i] = scope.lifePackages[i].item[0].id;
              scope.prices[person][i] = scope.lifePackages[i].item[0].price
            }
          }
          recalculateSummary();
          markVisibilityOfForms();
          realDeclarationsNumber();
        };

        scope.uncheck = function (keyPerson, keyGroup) {
          if (scope.choose[keyPerson][keyGroup]) {
            delete scope.choose[keyPerson][keyGroup];
          }
          scope.prices[keyPerson][keyGroup] = 0;
          for (let i = 0; i < scope.lifePackages.length; i++) {
            if (scope.isImplicit(scope.lifePackages[i])) {
              if (scope.choose[keyPerson][i]) {
                delete scope.choose[keyPerson][i];
              }
              if (scope.prices[keyPerson][i]) {
                delete scope.prices[keyPerson][i];
              }
            }
          }
          uncheckDependent(keyPerson, keyGroup);
          recalculateSummary();
          markVisibilityOfForms();
          realDeclarationsNumber();
        };

        scope.getColor = function (keyGroup) {
          if (scope.groupColors) {
            return scope.groupColors[keyGroup];
          } else {
            return scope.lifePackages[keyGroup].color;
          }
        }

        scope.isItemDisabled = function(keyPerson, keyGroup, keyItem) {
          return isOptionalGroup(keyGroup) && !isRequiredGroupChosen(keyPerson) || isItemExplicitlyDisabled(keyPerson, keyGroup, keyItem);
        }

        scope.isItemHidden = function(keyPerson, keyGroup, keyItem) {
          if (scope.isLifePackageHidden) {
            return scope.isLifePackageHidden()(keyPerson, keyGroup, keyItem);
          }
          return false;
        }

        scope.isImplicit = function(group) {
          return angular.isDefined(group.mandatory) && group.mandatory;
        }

        function isOptionalGroup(keyGroup) {
          return keyGroup > scope.requiredGroupsCount - 1;
        }

        function isRequiredGroupChosen(keyPerson) {
          return _.find(_.keys(scope.choose[keyPerson]), function (i) {
            return i < scope.requiredGroupsCount
          }) !== undefined;
        }

        function isItemExplicitlyDisabled(keyPerson, keyGroup, keyItem) {
          if (scope.isLifePackageDisabled) {
            let personPackage = scope.lifePackages[keyGroup];
            if (personPackage && personPackage.item && personPackage.item[keyItem]) {
                return  scope.isLifePackageDisabled()(personPackage.item[keyItem].id, keyPerson);
            }
          }
          return false;
        }

        function recalculateSummary() {
          scope.summary = 0;
          if (!angular.isDefined(scope.prices)) return;
          for (var a = 0; a < scope.prices.length; a++) {
            angular.forEach(scope.prices[a], function (singlePrice) {
              if (!singlePrice) {
                return;
              }
              scope.summary += singlePrice;
            });
          }
        }

        function recalculateImplicitPackagesPrice() {
          scope.implicitPackagesPrice = 0;
          if (!angular.isDefined(scope.lifePackages)) {
            return;
          }
          scope.implicitPackagesPrice = _.sum(
              scope.lifePackages
                  .filter(group => scope.isImplicit(group))
                  .map(group => _.sum(group.item.map(item => item.price)))
          )
        }
        function markVisibilityOfForms() {
          angular.forEach(scope.persons, function (singlePerson, personKey) {
            if (singlePerson.type === "USER") {
              return;
            }

            var singleChoose = scope.choose[personKey];
            if (!singleChoose) {
              singlePerson.hideForm = true;
              return;
            }
            var hideForm = !Object.keys(singleChoose).length;

            angular.forEach(singleChoose, function (chosenPackage) {
              if (hideForm) {
                return;
              }
              if (
                typeof chosenPackage === "undefined" ||
                chosenPackage === null
              ) {
                hideForm = true;
              }
            });
            singlePerson.hideForm = hideForm;
          });
        }

        function realDeclarationsNumber() {
          var realChooseLength = 0;
          angular.forEach(scope.choose, function (singleChoose) {
            var hasAny = false;
            angular.forEach(singleChoose, function (chosenPackages) {
              if (hasAny) {
                return;
              }
              if (chosenPackages) {
                hasAny = true;
              }
            });
            if (hasAny) {
              realChooseLength++;
            }
          });

          scope.realDeclarationsNumber = realChooseLength;
        }

        /**
         * If user unchecks the last checkbox from the main groups and a checkbox from an additional group is selected it will be unchecked;
         *
         * @param rowIndex
         * @param itemIndex
         */
        function uncheckDependent(rowIndex, itemIndex) {
          var uncheck = true;

          if (itemIndex >=  scope.requiredGroupsCount) return;

          for (var i = 0; i < scope.requiredGroupsCount; i++) {
            if (
              angular.isDefined(scope.choose[rowIndex][i]) &&
              scope.choose[rowIndex][i]
            )
              uncheck = false;
          }

          if (uncheck) {
            for (var i = scope.requiredGroupsCount; i < Object.keys(scope.lifePackages).length; i++) {
              if (scope.choose[rowIndex][i]) {
                delete scope.choose[rowIndex][i];
              }
              scope.prices[rowIndex][i] = 0;
            }
          }
        }

        function initialize() {
          variantsMatrixService.determineSingleAndAllLength(scope);
          variantsMatrixService.determineGroupwidth(scope);
          recalculateImplicitPackagesPrice();
          recalculateSummary();
          markVisibilityOfForms();
          realDeclarationsNumber();
        }

        initialize();
        scope.$onChanges = function (change) {
          if (change.lifePackages) {
            initialize();
          }
        };
      }
    };
  }
]);